import React, { useLayoutEffect, useMemo } from "react";
import "src/i18n";
import { ThemeProvider, CssBaseline } from "@mui/material";
import inputGlobalStyles from "./components/GlobalStyles";
import theme from "./theme";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from 'stylis';
import { createTheme } from '@mui/material/styles'
import { useTranslation } from "react-i18next";


const StyleWrapper = (props) => {
  const { i18n } = useTranslation();

  const direction = i18n.dir(i18n.language);

  const appliedTheme = useMemo(() => {
    return createTheme({ ...theme, direction });
  }, [direction])

  const cacheLtr = createCache({
    key: "muiltr",
    prepend: true,
    stylisPlugins: []
  });

  const cacheRtl = createCache({
    key: "muirtl",
    prepend: true,
    stylisPlugins: [prefixer, rtlPlugin]
  });

  useLayoutEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  return (
    <CacheProvider value={direction === "ltr" ? cacheLtr : cacheRtl}>
      <ThemeProvider theme={appliedTheme}>
        <CssBaseline>
          {inputGlobalStyles}
          {props.children}
        </CssBaseline>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default StyleWrapper;
